module.exports = require('./helpers/bundle-url').getBundleURL('4afSR') + "company_logo.403f7d6d.png";